<template>
  <div class="exam-result">
    <div class="exam-title">
      <div class="title" v-if="title">{{title}}</div>
      <div class="subhead">
        <div class="name-wrapper">
          姓名：<span>{{name}}</span>
        </div>
        <div class="score-wrapper">
          得分：<span class="score">{{score}}</span>
        </div>
      </div>
    </div>
    <div class="table-wrap" v-for="results in formatResults" :key="results.code">
      <div class="result-table">
        <div class="table-head">
          <div>{{getQuizName(results.code, 0)}}</div>
          <div></div>
          <div></div>
          <div></div>
          <div>我的</div>
        </div>
        <div class="table-body">
          <div class="item" v-for="(result, index) in results.list" :key="index">
            <div>{{index + 1}}</div>
            <div class="text">
              <div class="text-wrap">
                <van-speaker class="normal primary-u" :src="result.ref.audio"></van-speaker>
                <el-tooltip
                  effect="light"
                  transition=""
                  :content="result.ref.text"
                  :open-delay="400"
                  placement="right-start">
                  <span>&nbsp;{{result.ref.text}}</span>
                </el-tooltip>
              </div>
            </div>
            <el-tooltip
              effect="light"
              transition=""
              :disabled="result.ref.explain.length <= 18"
              :content="result.ref.explain"
              :open-delay="400"
              placement="right-start">
              <div>
                <span>{{result.ref.explain}}</span>
              </div>
            </el-tooltip>
            <div>
              <template v-if="result.ref.code === 'CHXZ'">
                <template v-if="result.answer">
                  <i class="el-icon-check success" v-if="result.isRight"></i>
                  <el-tooltip
                    effect="light"
                    transition=""
                    v-else
                    :content="result.answer"
                    :open-delay="400"
                    placement="right-start">
                    <span class="error">{{result.answer}}</span>
                  </el-tooltip>
                </template>
                <span class="error no-data" v-else>未作答</span>
              </template>
              <template v-else>
                <template v-if="result.answer">
                  <span class="success" v-if="result.isRight">{{result.answer}}</span>
                  <span class="error" v-else>{{result.answer}}</span>
                </template>
                <span class="error no-data" v-else>未作答</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Tooltip } from 'element-ui';
import VanSpeaker from 'vanthink-components/components/common/Speaker.vue';
import utils from '@/services/utils';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    results: {
      type: Array,
      default() {
        return [];
      },
    },
    score: {
      type: Number,
      default: 0,
    },
  },
  components: {
    VanSpeaker,
    ElTooltip: Tooltip,
  },
  computed: {
    name() {
      const { name } = utils.storage('account');
      return name;
    },
    formatResults() {
      const results = [];
      this.results.forEach((item) => {
        const index = utils.Array.findIndex(results, { code: item.ref.code }, 'code');
        if (index !== -1) {
          results[index].list.push(item);
        } else {
          results.push({
            code: item.ref.code,
            list: [{ ...item }],
          });
        }
      });
      return results;
    },
  },
  methods: {
    getQuizName(code, mode = 0) {
      return {
        CHXZ: {
          0: '词汇选择',
        },
        DCTX: {
          0: '单词听写',
        },
        DCPX: {
          0: '单词拼写',
        },
      }[code][mode];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .exam-result {
    color: #333;
    .exam-title {
      overflow: hidden;
      text-align: center;
      .title {
        margin-top: 40px;
        font-size: 2.4vh;
        font-weight: 700;
      }
      .subhead {
        margin: 30px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 2.4vh;
        font-weight: 700;
        div {
          margin: 0 10px;
          span {
            display: inline-block;
            padding: 2px 5px;
            font-size: 3vh;
            text-align: center;
            border-bottom: 2px solid $primary;
          }
          .score {
            color: $danger;
            font-size: 3.6vh;
          }
        }
      }
      .tagline {
        color: #999;
      }
    }
    .table-wrap {
      margin-bottom: 4vh;
      .result-table {
        margin: 0 auto;
        width: 90%;
        height: 100%;
        text-align: center;
        font-size: 18px;
        border-radius: 28px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,0.30);
        .table-head {
          width: 100%;
          padding: 15px 0;
          color: $primary;
          font-weight: 700;
          background: #EDEBFB;
          border-bottom: 1px solid $gray-bg-color;
          border-radius: 28px 28px 0 0;
          div {
            display: inline-block;
          }
          div:first-child {
            width: 10%;
          }
          div:nth-child(2) {
            width: 20%;
          }
          div:nth-child(3) {
            width: 35%;
          }
          div:nth-child(4) {
            width: 15%;
          }
          div:last-child {
            width: 20%;
          }
        }
        .table-body {
          width: 100%;
          max-height: calc(100% - 41px);
          overflow-y: auto;
          .item {
            width: 100%;
            border-bottom: 1px solid $gray-bg-color;
            .no-data {
              font-size: 16px!important;
            }
            div {
              display: inline-block;
              width: 22.5%;
              height: 60px;
              line-height: 60px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            div:first-child {
              width: 10%;
            }
            div:nth-child(2) {
              width: 20%;
            }
            div:nth-child(3) {
              width: 50%;
            }
            div:last-child {
              width: 20%;
            }
            .text {
              position: relative;
              .text-wrap {
                margin: 0 auto;
                padding-left: 60px;
                width: 60%;
                text-align: left;
              }
            }
            .error {
              font-size: 18px;
              font-weight: 700;
              color: $danger;
            }
            .success {
              font-size: 18px;
              font-weight: 700;
              color: $success;
            }
          }
          .item:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
</style>
